import LoaderCircle from '../../LoaderCircle';
import MailIcon from '../../../Assets/MailIcon';
import CopyIcon from '../../../Assets/CopyIcon';
import TrashIcon from '../../../Assets/TrashIcon';
import { maskApiToken } from '../../../Utils/HelperFunctions';

const ApiKeyTokenRow = ({ row, onDelete, onShare, deletingId, sharingId, onCopy }) => {
  const id = row.id;
  const isDeleting = deletingId === id;
  const isSharing = sharingId === id;
  const isLoading = isDeleting || isSharing;

  return (
    <tr className='border-t border-gray-100'>
      <td className='p-3'>{maskApiToken(row.token)}</td>
      <td className='p-3'>{row.created_by}</td>
      <td className='p-3 whitespace-nowrap'>{row.created_at ? new Date(row.created_at).toLocaleString() : '—'}</td>
      <td className='p-3 flex gap-4'>
        {isLoading ? (
          <LoaderCircle leftMargin={false} />
        ) : (
          <>
            <MailIcon className='cursor-pointer' aria-label='Share token with user' onClick={() => onShare(row)} />
            <TrashIcon className='cursor-pointer' aria-label='Delete token' onClick={() => onDelete(row.id)} />
          </>
        )}
        <CopyIcon className='cursor-pointer' aria-label='Copy token' onClick={() => onCopy(row.token)} />
      </td>
    </tr>
  );
};

export default ApiKeyTokenRow;
